(ns ui.view.entity-graph.components.toolbar
  (:require [clojure.string :as string]
            [re-frame.core :as rf]
            [reagent.core :as r]
            [common.entity :as entity]
            [common.localization :as loc]
            [common.schema.entities.graph-reference :as gref]
            [common.util :as cu]
            [frontend.routing :as routing]
            [frontend.page-components.zap-toolbar :as zap-toolbar]
            [frontend.state.current-session :as session]
            [ui.util :as uu]
;;            ["html-to-image" :as html-to-image]
            ;;["html2canvas" :as html2canvas]
            [ui.components.button.view :as button]
            [ui.components.toggle.view :as toggle]
            [ui.components.radix-ui.popover.view :as popover]
            [ui.components.radio-group.view :as radio-group]
            [ui.dom-globals :as dg]
            [ui.editors.data-input :as data-input]
            [ui.state.session.sub :as session-sub]
            [ui.view.entity-graph.model :as m]))

(def path-type-options
  [{:value :bezier :content (loc/tr :bezier)}
   {:value :straight :content (loc/tr :straight)}
   {:value :smooth-step :content (loc/tr :smooth-step)}])

#_(defn help
    [_ctx]
    (r/with-let [local-state (r/atom {})]
      [popover/view
       {:open? (:open? @local-state)
        :on-open-change
        (fn [val]
          (swap! local-state assoc :open? val))}
       [:i
        {:class-name "fal fa-question px-1 cursor-pointer"}]
       [:div
        [:div "* marks the main entity where the graph view was opened from."]
        [:div "Hold shift to select multiple nodes inside an area."]
        [:div "Hold ctrl and click individual nodes to select multiple."]]]))

(defn default-toggle
  [ctx {:keys [value default update! path label]}]
  (let [value (if (some? value)
                value
                @(rf/subscribe [m/default-value (assoc ctx
                                                       :path path
                                                       :default default)]))
        update! (or update!
                    (fn [new-val]
                      (rf/dispatch [m/update-defaults
                                    (assoc ctx
                                           :path path
                                           :value new-val)])))]
    [:div
     {:class    (uu/cm
                 "mb-0 p-2 cursor-pointer hover:bg-base-regular rounded"
                 "relative flex items-center justify-between gap-3")
      :on-click (fn [e]
                  (dg/prevent-and-stop e))}
     [:div
      {:class "m-0 flex"}
      [:span label]]
     [:div
      {:on-click dg/stop-propagation}
      [toggle/toggle
       {:checked? value
        :on-change update!}]]]))

(defn view-config-settings
  [ctx]
  (let [path-type @(rf/subscribe [m/default-path-type ctx])
        options path-type-options]
    [:div
     [:div
      {:role "menuitem"
       :class (uu/cm "min-w-48 mb-2 p-2 flex items-center gap-3 text-sm"
                     "text-base-light-text hover:bg-base-regular !outline-0"
                     "shadow-none rounded cursor-pointer")
       :on-click (fn [_]
                   (rf/dispatch [m/export-visible ctx]))}
      [:div
       {:class (uu/cm "flex flex-row items-center gap-2")}
       (loc/tr :export-as-excel)]]
     [:div
      {:class (uu/cm "pb-3"
                     "pt-3 flex flex-col gap-3"
                     "border-t border-solid border-base-light-border-paler")}
      [default-toggle
       ctx {:label (loc/tr :hide-grid)
            :default true
            :path [m/hide-grid-key]}]
      [default-toggle
       ctx {:label (loc/tr :autolayout-new-nodes)
            :value (not @(rf/subscribe [m/manual-positions?
                                        ctx]))
            :default false
            :update!
            (fn [new-val]
              ;; auto-layout-new-nodes is boolean complement of ':manual-positions?':
              (let [manual-positions-value (if new-val
                                             nil
                                             true)]
                ;; if we want to run autolayout for existing nodes, use
                ;; m/discard-positions (assoc ctx :auto-layout? true)
                (rf/dispatch-sync
                 [m/set-manual-positions
                  (assoc ctx :value manual-positions-value)])))}]
      (when @(rf/subscribe [m/has-pep-attribute? ctx])
        [default-toggle
         ctx {:label (loc/tr :highlight-pep)
              :default true
              :path [m/highlight-pep-key]}])]
     [default-toggle
      ctx {:label (loc/tr :show-icons)
           :default true
           :path [m/show-icons-key]}]

     #_[:div
        {:class (uu/cm "save-as-image")}
      ;;TODO html2img?
        #_[:div "Save selection as image"]
        #_[:div "Save canvas as image"]]
     [:div
      {:class (uu/cm "pt-3 flex flex-col gap-3 border-t border-solid border-base-light-border-paler")}
      [:div
       {:class "m-0 text-sm text-base-light-text-paler"}
       (loc/tr :set-default-path-shape)]
      [radio-group/radio-group-v2
       {:checked path-type
        :name "default-path-type"
        :on-change (fn [new-val]
                     (when-not (= new-val path-type)
                       (rf/dispatch [m/update-defaults
                                     (assoc ctx
                                            :path m/path-type-path
                                            :value new-val)])))}
       options]]]))

(defn view-config-popover
  [{:keys [] :as ctx}]
  (r/with-let [open? (r/atom false)]
    [popover/view
     {:open? @open?
      ;;TODO also reset relevant re-frame-db state?
      :on-open-change (r/partial reset! open?)}
     [:span
      [:button
       {:class "w-6 h-6 flex justify-center items-center rounded hover:bg-base-regular hover:text-base-light-text-paler"}
       [:i.fal.fa-ellipsis-v
        {:class "text-xl"}]]]
     [view-config-settings ctx]]))

(defn connector-path-type-config
  [{:keys [connector-type] :as ctx}]
  (let [path-type @(rf/subscribe [m/default-connector-path-type ctx])
        path (into [connector-type] m/path-type-path)
        view-default @(rf/subscribe [m/default-path-type ctx])
        view-default-str (loc/tr view-default)
        default-opt-str (loc/tr :use-view-default [view-default-str])
        options (into [{:value nil :content default-opt-str}]
                      path-type-options)]
    [:div
     {:class (uu/cm "flex flex-col gap-4")}
     [:div
      {:class (uu/cm "font-semibold")}
      (loc/tr :connector-path-shape)]
     [radio-group/radio-group-v2
      {:checked path-type
       :name "default-path-type"
       :on-change (fn [new-val]
                    (when-not (= new-val path-type)
                      (rf/dispatch [m/update-defaults
                                    (assoc ctx
                                           :path path
                                           :value new-val)])))}
      options]]))

(def handle-radio-options
  (->> [:bottom :right :left :top]
       (mapv (fn [k]
               {:value k :content (loc/tr k)}))))

(defn end-point-config
  [{:keys [connector-type] :as ctx}]
  (let [source-handle (or @(rf/subscribe
                            [m/default-connector-source-handle ctx])
                          (get m/default-source-handle-by-type connector-type))
        target-handle (or @(rf/subscribe
                            [m/default-connector-target-handle ctx])
                          (get m/default-target-handle-by-type connector-type))
        source-path [m/source-handle-key connector-type]
        target-path [m/target-handle-key connector-type]]
    [:div
     {:class (uu/cm "flex flex-col gap-4")}
     [:div
      {:class (uu/cm "font-semibold")}
      (loc/tr :connector-endpoints)]
     [:div
      {:class (uu/cm "flex gap-4")}
      [:div
       {:class (uu/cm "flex flex-col gap-1")}
       [:div
        {:class "m-0 text-sm text-base-light-text-paler"}
        (loc/tr :endpoint/from)]
       [radio-group/radio-group-v2
        {:checked source-handle
         :name "default-source-handle"
         :on-change (fn [new-val]
                      (when-not (= new-val source-handle)
                        (rf/dispatch [m/update-defaults
                                      (assoc ctx
                                             :path source-path
                                             :value new-val)])))}
        handle-radio-options]]
      [:div
       {:class (uu/cm "flex flex-col gap-1")}
       [:div
        {:class "m-0 text-sm text-base-light-text-paler"}
        (loc/tr :endpoint/to)]
       [radio-group/radio-group-v2
        {:checked target-handle
         :name "default-target-handle"
         :on-change (fn [new-val]
                      (when-not (= new-val target-handle)
                        (rf/dispatch [m/update-defaults
                                      (assoc ctx
                                             :path target-path
                                             :value new-val)])))}
        handle-radio-options]]]]))

(defn connector-color-config
  [_ctx]
  [:div
   {:class (uu/cm "flex flex-col gap-1")}
   [:div
    {:class (uu/cm "font-bold")}
    "Connector color"]
   [:div
    "TODO green"]
   [:div
    "pink"]
   [:div
    "red"]])

(def line-type-options
  (->> [:solid :dashed]
       (mapv (fn [k]
               {:value k :content (loc/tr k)}))))

(defn connector-line-type-config
  [{:keys [connector-type] :as ctx}]
  (let [line-type (or @(rf/subscribe
                        [m/default-connector-line-type ctx])
                      (get m/default-line-type-by-type connector-type :solid))
        path [m/line-type-key connector-type]]
    [:div
     {:class (uu/cm "flex flex-col gap-4")}
     [:div
      {:class (uu/cm "font-semibold")}
      (loc/tr :connector-line-type)]
     [:div
      {:class (uu/cm "flex flex-col gap-1")}
      [radio-group/radio-group-v2
       {:checked line-type
        :name "default-source-handle"
        :on-change (fn [new-val]
                     (when-not (= new-val line-type)
                       (rf/dispatch [m/update-defaults
                                     (assoc ctx
                                            :path path
                                            :value new-val)])))}
       line-type-options]]]))

(defn connector-hider
  [{:keys [connector-type] :as ctx}]
  (let [reachable-connectors @(rf/subscribe [m/reachable-connectors-of-type ctx])
        system-config @(rf/subscribe [m/selected-system-config ctx])
        hide-rules @(rf/subscribe [m/hide-rules ctx])
        ;;explicitly hidden connectors
        hidden-connectors (:connectors hide-rules)
        hidden-reachable (->> reachable-connectors
                              (into #{}
                                    (comp
                                     (filter (fn [{:keys [db/id]}]
                                               (contains? hidden-connectors id)))
                                     (map :db/id))))
        any-hidden? (seq hidden-reachable)
        toggle-checked? (if system-config
                          (not (contains? (get-in m/system-level-configs
                                                  [system-config
                                                   :hide-connector-types])
                                          connector-type))
                          (not any-hidden?))
        connector-ids (if any-hidden?
                        hidden-reachable
                        (->> @(rf/subscribe [m/visible-connectors-of-type ctx])
                             (into #{}
                                   (map :db/id))))]
    [:div
     {:class (uu/cm "flex gap-4 pb-3 border-b border-solid border-base-light-border-paler")}
     [:div
      {:class (uu/cm "font-bold")}
      (loc/tr :connector-config-title [(loc/tr connector-type)])]
     [:div
      {:class "flex items-center gap-2"}
      [toggle/toggle
       {:checked? toggle-checked?
        :on-change (fn [_]
                     (rf/dispatch [m/hide-all
                                   (assoc ctx
                                          :show? (not toggle-checked?)
                                          :connector-type connector-type
                                          :connector-ids connector-ids)]))}]
      [:div
       {:class "m-0 text-xs text-base-light-text-paler"}
       (loc/tr :show)]]]))

(defn connector-config
  [{:keys [connector-type] :as ctx}]
  (r/with-let [local-state (r/atom {})]
    (let [open? (:open? @local-state)]
      [popover/view
       {:open? open?
        :on-open-change
        (fn [val]
          (swap! local-state assoc :open? val))}
       [:div
        {:class (uu/cm "m-0 py-1 px-2 md:px-3 cursor-pointer bg-base-regular hover:bg-secondary-light rounded-full text-sm"
                       (when open?
                         "bg-base-regular hover:bg-secondary-light"))}
        (loc/tr connector-type)]
       [:div
        {:class (uu/cm "flex flex-col gap-2")}
        [connector-hider ctx]
        [:div
         [:div
          {:class (uu/cm "flex flex-col lg:flex-row gap-6 divide-y lg:divide-y-0 lg:divide-x divide-solid divide-base-light-border-paler")}
          [:div
           {:class "p-3"}
           [connector-path-type-config ctx]]
          [:div
           {:class "p-3"}
           [end-point-config ctx]]
          #_[:div
             [connector-color-config ctx]]
          [:div
           {:class "p-3"}
           [connector-line-type-config ctx]]]
         [popover/popover-arrow
          {:class "fill-complement-light"}]]]])))

(defn connectors-config
  [ctx]
  [:div
   {:class (uu/cm "flex gap-1")}
   (for [connector-type gref/ordered-connector-types]
     ^{:key (str connector-type)}
     [connector-config (assoc ctx :connector-type connector-type)])])

#_(defn has-class?
  [^js node class-str]
  (string/includes? (str (.-className node)) class-str))

#_(defn to-image-filter
  [^js node]
  #_(not= (cu/str-trim-lcase (.-tagName node)) "button")
  (let [val (and (not (has-class? node "react-flow-controls"))
                 (not= (cu/str-trim-lcase (.-tagName node)) "a"))]
    val))

#_(defn save-as-image
  [{:keys [main-entity-id]} image-type]
  (let [flow-id (str "flow-" main-entity-id)
        ^js containing-node (js/document.getElementById flow-id)
        ^js node (js/document.querySelector ".react-flow__viewport")
        ^js node (js/document.getElementById flow-id)
        rect (.getBoundingClientRect containing-node)
        width (.-width rect)
        height (.-height rect)
        ;;TODO timestamp to filename?
        filename (case image-type
                   :png "entity-map.png"
                   :svg "entity-map.svg"
                   "entity-map.png")
        viewport-x 0
        viewport-y 0
        zoom 1.0
        ;;`translate(${viewport.x}px, ${viewport.y}px) scale(${viewport.zoom})`
        tfm (str "translate(" viewport-x "px, " viewport-y "px) scale("
                 zoom
                 ")")
        ;;
        opts #js {:filter to-image-filter
                  :cacheBust true
                  :includeQueryParams true
                  ;;:width width
                  ;;:height height
                  :style #js {:backgroundColor "#1a365d"
                              ;;:width width
                              ;;:height height
                              }}
        _ (doseq [svg-node (.querySelectorAll node "svg")]
            (let [rect (.getBoundingClientRect svg-node)
                  g-node (.querySelector svg-node "g")
                  data-id (when g-node
                            (.getAttribute g-node "data-id"))
                  w (.-width rect)
                  h (.-height rect)]
              (when true;;g-node
                ;;(prn ">w h data-id" w h data-id)
                (.setAttribute svg-node "width" w)
                (.setAttribute svg-node "height" h)
                ;;(.setAttribute svg-node "style" "z-index: 2;")
                )))
        prom (case image-type
               :png (.toPng html-to-image node opts)
               :svg (.toSvg html-to-image node opts))]
    (-> prom
        (.then (fn [data-url]
                 #_(let [date (-> data-url
                                  (string/split #",")
                                  second)
                         svg (js/decodeURIComponent data)]
                     (prn ">svg" (subs svg 0 200)))
                 (let [svg-part (when (= image-type :svg)
                                  (-> data-url
                                      (string/split #",")
                                      second))
                       data-url (if false;;(= image-type :svg)
                                  (js/decodeURIComponent svg-part)
                                  data-url)

                       ^js link (js/document.createElement "a")]
                   (set! (.-download link) filename)
                   (set! (.-href link) data-url)
                   (.click link))))
        (.catch (fn [err]
                  #_(rf/dispatch [:error-event nil nil]))))))

#_(defn save-as-image-2
  [{:keys [main-entity-id] :as ctx} image-type]
  (let [flow-id (str "flow-" main-entity-id)
        ^js node (js/document.getElementById flow-id)]
    #_(doseq [svg-node (.querySelectorAll node "svg")]
        (let [rect (.getBoundingClientRect svg-node)
              g-node (.querySelector svg-node "g")
              data-id (when g-node
                        (.getAttribute g-node "data-id"))
              w (.-width rect)
              h (.-height rect)]
          (when true;;g-node
          ;;(prn ">w h data-id" w h data-id)
            (.setAttribute svg-node "width" w)
            (.setAttribute svg-node "height" h)
          ;;(.setAttribute svg-node "style" "z-index: 2;")
            )))

    (.then
     (js/html2canvas node #js {:allowTaint true
                               :foreignObjectRendering true
                               #_#_:ignoreElements to-image-filter
                               :useCORS true})
     (fn [canvas-element]
       (.toBlob
        canvas-element
        (fn [^js blob]
          (let [^js link (js/document.createElement "a")
                url (js/URL.createObjectURL blob)]
            (set! (.-download link) "entity-graph.png")
            (set! (.-href link) url)
            (.click link))))))))

(defn toolbar-buttons
  [ctx]
  [:div
   {:class (uu/cm "flex gap-1")}
   ;; testing different export-as-img libraries
   ;; TODO later
   #_[button/sm-secondary-solid
      {:on-click
       (fn [_]
         (save-as-image-2 ctx :png)
         #_(rf/dispatch [m/export-visible
                         (assoc ctx
                                :map-profiles
                                @(rf/subscribe
                                  [m/visible-map-profiles ctx])
                                :connectors
                                @(rf/subscribe
                                  [m/visible-connectors ctx]))]))}
      "Another png"]
   #_[button/sm-secondary-solid
      {:on-click
       (fn [_]
         (save-as-image ctx :png)
         #_(rf/dispatch [m/export-visible
                         (assoc ctx
                                :map-profiles
                                @(rf/subscribe
                                  [m/visible-map-profiles ctx])
                                :connectors
                                @(rf/subscribe
                                  [m/visible-connectors ctx]))]))}
      "Save as png"]
   #_[button/sm-secondary-solid
      {:on-click
       (fn [_]
         (save-as-image ctx :svg)
         #_(rf/dispatch [m/export-visible
                         (assoc ctx
                                :map-profiles
                                @(rf/subscribe
                                  [m/visible-map-profiles ctx])
                                :connectors
                                @(rf/subscribe
                                  [m/visible-connectors ctx]))]))}
      "Save as svg"]
   [button/helper-button
    {:on-click
     (fn [_]
       (rf/dispatch [m/auto-layout-nodes
                     (assoc ctx
                            :map-profiles
                            @(rf/subscribe
                              [m/visible-map-profiles ctx])
                            :connectors
                            @(rf/subscribe
                              [m/visible-connectors ctx]))]))}
    (loc/tr :auto-position)]])

(defn save-current-config
  [ctx]
  (r/with-let [local-state (r/atom {})
               modify! (fn [k v] (swap! local-state assoc k v))
               modify-name! (fn [v]
                              (modify! :name v))]
    (let [{:keys [name]} @local-state
          save-button-disabled? (->> name
                                     string/blank?)]
      [:div
       {:class "flex flex-col gap-3"}
       [:div
        {:class "font-bold"}
        (loc/tr :need-current-view-config-often)]
       [:div
        {:class "text-complement-light-text-paler"}
        (loc/tr :save-current-view-config-info)]
       [:div
        {:class "grid grid-cols-10 gap-3 items-center"}
        [:div
         {:class "col-span-8"}
         [data-input/view
          {:data-type   :data.type/text-simple
           :class       "w-full"
           :placeholder (loc/tr :type-a-view-name)
           :value       name
           :on-change   modify-name!}]]
        [:div
         {:class "col-span-2"}
         [button/sm-primary-solid
          {:class "h-[38px]"
           :disabled? save-button-disabled?
           :tooltip   (when save-button-disabled?
                        (loc/tr :name-cannot-be-blank))
           :on-click  (fn [_]
                        (rf/dispatch [m/save-view-config
                                      (assoc ctx
                                             :view-config-name name)]))}
          [:span (loc/tr :save)]]]]])))

;; a quick hack - m/start-delete is currently specific to graph-references:
(defn delete-graph-config!
  [_ctx graph-config]
  ((:on-select (zap-toolbar/delete-button
               graph-config nil identity))))

;; system-level view-configs:
;; "Ownerships", "GPs and LPs", "Only LPs"
;; -if "Ownerships" is selected AND user creates LP-connection
;;  => new LP-connection should be shown AND "Ownerships" is no longer active
;;     (back to "Custom view config")
;; -if user creates Ownership-connection => "Ownerships" config still applies
;; -if someone else creates LP-connection => "Ownerships" still applies i.e. no
;;  change for current user
(defn get-system-configs
  [_ctx]
  [{:graph-config/name (loc/tr :system-view-config/ownerships)
    :system-level? true
    :db/id m/ownerships-config
    :graph-config/config
    {}}
   {:graph-config/name (loc/tr :system-view-config/gps-and-lps)
    :system-level? true
    :db/id m/gps-and-lps-config
    :graph-config/config
    {}}
   {:graph-config/name (loc/tr :system-view-config/lps)
    :system-level? true
    :db/id m/lps-config
    :graph-config/config
    {}}])

(defn view-selector
  [ctx {:keys [close-popover!]}]
  (let [saving-disabled? @(r/track session/is-read-only-user?)
        account-id @(rf/subscribe [::session-sub/account-id])
        configs @(rf/subscribe [m/view-configs ctx])
        current-config @(rf/subscribe [m/view-config ctx])
        system-config @(rf/subscribe [m/selected-system-config ctx])
        system-configs (get-system-configs ctx)
        matching-config (->> configs
                             (filter (fn [{:keys [graph-config/config]}]
                                       (= (cu/remove-empty-vals config)
                                          (cu/remove-empty-vals current-config))))
                             first)
        matching-config (if system-config
                          (->> system-configs
                               (filter (fn [{:keys [db/id]}]
                                         (= id system-config)))
                               first)
                          matching-config)
        custom? (not matching-config)]
    [:div
     {:class (uu/cm "max-w-[320px] lg:max-w-[600px] m-0 flex p-3 rounded text-sm"
                    "text-base-light-text")}
     [:div
      {:class "md:flex gap-6"}
      [:div
       {:class "flex flex-col gap-3 min-w-36"}
       [:div
        {:class "pb-1 text-base-light-text font-bold"}
        (loc/tr :select-view)]
       (doall
        (for [graph-config (into system-configs configs)
              :let [id (:db/id graph-config)
                    config (:graph-config/config graph-config)
                    system-level? (:system-level? graph-config)
                    name (:graph-config/name graph-config)]]
          ^{:key (str "name-view-" id "-" name)}
          [:div
           {:class    (uu/cm "max-w-full flex gap-2 items-center justify-between text-base-light-text"
                             "hover:text-base-light-text-accent truncate group/view-config"
                             "cursor-pointer"
                             (when (= id (:db/id matching-config))
                               "selected font-semibold"))
            :on-click   (fn [_]
                          (if system-level?
                            (rf/dispatch [m/select-system-config
                                          (assoc ctx
                                                 :config graph-config)])
                            (rf/dispatch [m/load-view-config (assoc ctx
                                                                    :config config)]))
                          (close-popover!))}
           [:span
            {:title name
             :class "block max-w-10/12 truncate"}
            name]
           (when (int? id)
             [:div
              {:class "flex gap-1"}
              #_(when (and (not (session/is-read-only-user?))
                           (->> accounts-with-view-access
                                (cu/remove-by :db/id @session/account-id)
                                (seq)))
                  [button/square-secondary-open
                   {:on-click (fn [e]
                                (.preventDefault e)
                                (.stopPropagation e)
                                (share-view! id))}
                   [:i.fal.fa-share]])
              ;; allow delete only if owner:
              (when (= account-id (:common/owner graph-config))
                [button/square-secondary-open
                 {:on-click (fn [e]
                              (.preventDefault e)
                              (.stopPropagation e)
                              (delete-graph-config! ctx graph-config)
                              (close-popover!))}
                 [:i
                  {:class (uu/cm "fal fa-trash-alt invisible"
                                 "group-hover/view-config:visible")}]])])]))]
      (when (and custom? (not saving-disabled?))
        [save-current-config ctx])]
     [popover/popover-arrow
      {:class "fill-complement-light"}]]))

(defn view-selector-trigger
  [ctx]
  (let [configs @(rf/subscribe [m/view-configs ctx])
        current-config @(rf/subscribe [m/view-config ctx])
        system-config @(rf/subscribe [m/selected-system-config ctx])
        matching-config (->> configs
                             (filter (fn [{:keys [graph-config/config]}]
                                       (= (cu/remove-empty-vals config)
                                          (cu/remove-empty-vals current-config))))
                             first)
        matching-config (if system-config
                          (->> (get-system-configs ctx)
                               (filter (fn [{:keys [db/id]}]
                                         (= id system-config)))
                               first)
                          matching-config)
        config-text (or (:graph-config/name matching-config)
                        (loc/tr :custom-view-config))
        tooltip-text config-text]
    [button/secondary-open
     {:tooltip tooltip-text
      :class   "md:w-48 mb-0 !py-0 text-sm"}

     [:div
      {:class "max-w-full flex items-center gap-3"}
      [:i.fal.fa-eye]
      [:span
       {:class "max-w-10/12 hidden md:block truncate whitespace-nowrap"}
       config-text]]]))

(defn view-selector-popover
  [ctx]
  ;; for reference:
  ;; frontend.react.virtualized.scrollable-grid.components/named-view-selector
  (r/with-let [open? (r/atom false)
               close-popover! (fn []
                                (reset! open? false))]
    [popover/view
     {:open? @open?
      :z-index 1054
      :as-child? true
      :on-open-change (r/partial reset! open?)}
     [view-selector-trigger ctx]
     [view-selector ctx {:close-popover! close-popover!}]]))

(defn view
  [{:keys [main-entity-id] :as ctx}]
  (let [entity @(rf/subscribe [::session-sub/entity main-entity-id])]
    [:div
     {:class     (uu/cm "flex items-center justify-between"
                        "py-1")
      :on-click (fn [_]
                  (rf/dispatch [m/close-node-menu ctx])
                  (rf/dispatch [m/close-edge-menu ctx]))}
     [:div
      {:class      (uu/cm "entity-graph-toolbar-left"
                          "flex gap-2 items-end items-center")}
      [button/secondary-open
       {:class "py-0"
        :on-click
        (fn [_]
          (routing/open-entity main-entity-id))}
       [:span
        {:class
         (uu/cm "d-flex align-items-center")}
        [:i
         {:class "fal fa-angle-left"}]
        [:span
         {:class "font-bold mx-1"}
         (entity/display-string entity) " *"]]]
      (when-not @(rf/subscribe [m/loaded? ctx])
        [:div
         (loc/tr :loading)])
      [connectors-config ctx]]
     [:div
      {:class (uu/cm
               "entity-graph-toolbar-right"
               "flex gap-2 items-center")}
      #_[entity-types-config ctx]
      [view-selector-popover ctx]
      #_[:button
         {:style {;;:margin "2px"
                  :border "1px solid black"}
          :on-click
          (fn [_]
            (rf/dispatch [m/open-settings ctx]))}
         "Settings"]
      #_[help ctx]
      ;;TODO notification when unsaved changes?
      #_[:div
         {:class-name ""}
         "(Frontent-only-version)"]
      [toolbar-buttons ctx]
      [view-config-popover ctx]]]))
